import { Module } from '@nestjs/common';
import { LotClubbingController } from './lot-clubbing.controller';
import { LotClubbingService } from './lot-clubbing.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { MatserClubbedLots } from './lot-clubbing.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
@Module({
  imports: [
    TypeOrmModule.forFeature([MatserClubbedLots])
  ],
  controllers: [LotClubbingController],
  providers: [LotClubbingService , ApplicationExceptionHandler
    // ,ProductConversionAdapter,ApplicationExceptionHandler,SaleOrderService
]
})
export class LotClubbingModule {}
